import { PropertyType } from '@app/models/enums'
import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import { List } from 'immutable'
import * as React from 'react'
import Select from 'react-select'

interface IPropertyTypeProps {
  bsSize?: 'sm' | 'lg' | undefined
  includeAllOption?: boolean
  className?: string
  onChange: (value: List<PropertyType>) => void
  placeholder?: string | JSX.Element
  required?: boolean
  style?: React.CSSProperties
  value: List<PropertyType>
}

type IComponentProps = IPropertyTypeProps & IGlobalConfigurationState

export default class PropertyTypeSelector extends React.PureComponent<
  IComponentProps
> {
  private selectRef: React.RefObject<HTMLDivElement>
  private propertyTypes: { label: string; value: string }[]
  constructor(props: IComponentProps) {
    super(props)
    this.selectRef = React.createRef()
    this.propertyTypes = this.props.value
      .map((x) => {
        return { label: humanize(x), value: x?.toString() ?? '' }
      })
      .toArray()
    bindFunctions(this)
  }

  public render() {
    return (
      <div className={this.props.className} ref={this.selectRef}>
        <Select
          styles={{
            control: (base) => ({
              ...base,
              fontSize: 'sm',
              border: 'hb-gray-700',
              textDecoration: '$hb-gray',
              ':focus': {
                borderColor: '$hb-gray',
              },
              bottom: '3px',
              height: '80%',
              color: '#11111',
              caretColor: 'red',
            }),
          }}
          classNames={{
            control: () => this.props.className ?? '',
          }}
          isMulti
          defaultValue={this.propertyTypes}
          placeholder={'Add property types...'}
          options={this.props.configuration.propertyTypes
            .map((propType) => {
              return {
                label: humanize(propType),
                value: propType?.toString() ?? '',
              }
            })
            .toArray()}
          onChange={(e: any) => {
            const propertyTypes = Array.isArray(e)
              ? e.map((propertyType) => propertyType.value)
              : [e.value]
            this.props.onChange(List<PropertyType>(propertyTypes))
          }}
        />
      </div>
    )
  }
}
